import { CampaignsPage } from '@/features/campaigns/campaigns-page'
import { LinkedInRequiredGate } from '@/components/linkedin-required-gate'

export default function CampaignsRoute() {
  return (
    <LinkedInRequiredGate
      featureName="Campaigns"
      description="Outreach campaigns send connection requests, DMs, and follow-ups through your LinkedIn account. Connect one to launch your first campaign."
    >
      <CampaignsPage />
    </LinkedInRequiredGate>
  )
}
